/**
 * @Author: 左建
 * @Date: 2022/6/30 10:24
 * @LastEditTime: 2022/6/30 10:24
 * @Description:  声明全卷组件
*/

import GoBack from "./GoBack";
import Breadcrumbs from "./Breadcrumbs/Breadcrumbs";
import ZjDatePicker from "./Form/ZjDatePicker/ZjDatePicker";
import BarChart from "@/components/Charts/BarChart/BarChart";
import LineChart from "@/components/Charts/LineChart/LineChart";
import PieChart from "@/components/Charts/PieChart/PieChart";
import ZjProgress from "@/components/ZjProgress/ZjProgress";
export default {
    GoBack,
    Breadcrumbs,
    ZjDatePicker,
    BarChart,
    LineChart,
    PieChart,
    ZjProgress
}
